import { axiosCore } from './http-core-service';
import { ResetPasswordDto } from './dtos/reset-password.dto';
import { UserAccountDto } from './dtos/user-account.dto';
import { ResultSearchDto } from './dtos/result-search.dto';
import { UserAdminDto } from './dtos/user-admin.dto';

/**
 * Méthode qui récupère les utilisateurs
 * @param page page à récupérer
 * @param itemsPerPage nombre d'éléments par page
 * @param search filtre optionnel sur l'adresse mail
 * @return liste des utilisateurs
 */
export const getUsers = async (
    page: number,
    itemsPerPage: number,
    search?: string
): Promise<ResultSearchDto<UserAdminDto>> => {
    // Création d'un json pour la requête
    let url = `/api/users?page=${page}&itemsPerPage=${itemsPerPage}`;
    if (search) {
        url += `&search=${encodeURIComponent(search)}`;
    }
    const response = await axiosCore.get(url);
    return response.data;
};

/**
 * Méthode qui valide les mots de passe
 * @return si valide
 */
export const isValidPassword = async (password: string) => {
    // Création d'un json pour la requête
    let data = {
        password: password,
    };
    const response = await axiosCore.post('/api/password/validate', data);
    return response.data;
};

/**
 * Méthode qui permet de changer de mot de passe (utilisateur authentifié courant)
 * @param data données du mot de passe
 */
export const updatePassword = async (data: ResetPasswordDto) => {
    const response = await axiosCore.patch(`/api/users/update_password`, data);
    return response.data;
};

export const confirmResetPassword = async (token: string, data: ResetPasswordDto) => {
    const response = await axiosCore.patch('/api/users/reset_password/confirm', {
        token: token,
        newPassword: data.newPassword,
        confirmPassword: data.confirmPassword,
    });
    return response.data;
};

/**
 * Méthode pour récupérer les informations d'une personne
 *
 * @param id identifiant de la personne
 */
export const getUsersInfos = async (id: string): Promise<UserAccountDto> => {
    const response = await axiosCore.get(`/api/users/${id}/infos`);
    return response.data;
};

/**
 * Méthode qui récupère les données de l'utilisateur
 */
export const getCurrentAccountUser = async (): Promise<UserAccountDto> => {
    const response = await axiosCore.get(`/api/users/infos/connected`);
    return response.data;
};

/**
 * Sends a change report for a user account.
 */
export const sendChangeReport = async (id: string, data: UserAccountDto, mandateId?: string) => {
    //Ajout du critère
    let criterions = '';
    if (mandateId) {
        criterions += `?mandateId=${mandateId}`;
    }

    const response = await axiosCore.put(`/api/users/${id}/report-change${criterions}`, data);
    return response.data;
};

/**
 * Confirme un changement d'adresse email.
 */
export const confirmEmailChange = async (token: string) => {
    const response = await axiosCore.get(`/api/users/email-change/confirm?token=${encodeURIComponent(token)}`);
    return response.data;
};
